var _desc, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.0625,
    height: 29.895996,
    viewBox: "0 0 23.0625 29.896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.68 9.82L13.23 0.37C13 0.13 12.67 0 12.33 0L4.69 0C3.45 0 2.25 0.49 1.37 1.37C0.49 2.25 0 3.45 0 4.69L0 25.19C0 26.44 0.49 27.63 1.37 28.52C2.25 29.4 3.45 29.89 4.69 29.89L18.36 29.89C19.61 29.89 20.8 29.4 21.68 28.52C22.56 27.63 23.06 26.44 23.06 25.19L23.06 10.67C23.04 10.35 22.91 10.05 22.68 9.82ZM13.66 4.37L18.68 9.39L13.66 9.39L13.66 4.37ZM18.36 27.33L4.69 27.33C4.13 27.33 3.58 27.1 3.18 26.7C2.78 26.3 2.56 25.76 2.56 25.19L2.56 4.69C2.56 4.13 2.78 3.58 3.18 3.18C3.58 2.78 4.13 2.56 4.69 2.56L11.1 2.56L11.1 10.67C11.1 11.01 11.24 11.33 11.48 11.57C11.72 11.81 12.04 11.95 12.38 11.95L20.5 11.95L20.5 25.19C20.5 25.76 20.27 26.3 19.87 26.7C19.47 27.1 18.93 27.33 18.36 27.33Z",
    fill: "#7252DC",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12 L9 20 L16 16 Z",
    fill: "#7252DC",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFileIcon);
export default __webpack_public_path__ + "static/media/videoFileIcon.21714fdd4122fc1ee49cc1c17f952abf.svg";
export { ForwardRef as ReactComponent };